import css from './ButtonWrapper.module.scss';

export default function ButtonsWrapper({children}) {
  return (
    <div className={css.buttonsWrapper}>
      {children}
    </div>
  );
}